import TemplateSettings from './template-settings/template-settings.vue'
import {
  AlbumSelect,
  AlbumSelectGroup,
  CheckboxInputGroup,
  ColorSelectGroup,
  ColumnSelect,
  DatasetSelect,
  DatasetSelectGroup,
  NumberInputGroup,
  PictureSelect,
  PictureSelectGroup,
  RecordSelect,
  RecordSelectGroup,
  SwitchButtons,
  TableEdit,
  TemplateSelect,
  TextInputGroup
} from './ui'
import AlbumWindow from './album.vue'
import DatasetWindow from './dataset.vue'
import RaceResultDatasetWindow from './race-result-dataset.vue'
import UiaaResultsCenterDatasetWindow from './uiaa-results-center-dataset.vue'
import ProducerWindow from './producer-window.vue'
import Templates from './templates'
import TemplateNotFound from './template-not-found.vue'
import TemplateLibrary from './template-library.vue'
import VerticalLifeDatasetWindow from './vertical-life-dataset.vue'
import Window from './window.vue'
import WindowTab from './window-tab.vue'
import WindowTabs from './window-tabs.vue'

const Components = {
  install (Vue) {
    Vue.component('template-settings', TemplateSettings)

    Vue.component('album-select', AlbumSelect)
    Vue.component('album-select-group', AlbumSelectGroup)
    Vue.component('checkbox-input-group', CheckboxInputGroup)
    Vue.component('color-select-group', ColorSelectGroup)
    Vue.component('column-select', ColumnSelect)
    Vue.component('dataset-select', DatasetSelect)
    Vue.component('dataset-select-group', DatasetSelectGroup)
    Vue.component('number-input-group', NumberInputGroup)
    Vue.component('picture-select', PictureSelect)
    Vue.component('picture-select-group', PictureSelectGroup)
    Vue.component('switch-buttons', SwitchButtons)
    Vue.component('record-select', RecordSelect)
    Vue.component('record-select-group', RecordSelectGroup)
    Vue.component('table-edit', TableEdit)
    Vue.component('template-select', TemplateSelect)
    Vue.component('text-input-group', TextInputGroup)

    Vue.component('album-window', AlbumWindow)
    Vue.component('dataset-window', DatasetWindow)
    Vue.component('race-result-dataset-window', RaceResultDatasetWindow)
    Vue.component('uiaa-dataset-window', UiaaResultsCenterDatasetWindow)
    Vue.component('vertical-life-dataset-window', VerticalLifeDatasetWindow)

    Vue.component('producer-window', ProducerWindow)

    Templates.install(Vue)

    Vue.component('template-not-found', TemplateNotFound)
    Vue.component('template-library', TemplateLibrary)

    Vue.component('window', Window)
    Vue.component('window-tab', WindowTab)
    Vue.component('window-tabs', WindowTabs)
  }
}

export default Components



// WEBPACK FOOTER //
// ./src/components/index.js